import { BseDto } from "../../autogen/bff-api";

export const eventIsCancelled = (event: BseDto): boolean => {
  return event.status === "Cancelled";
};
